import Vue from 'vue';
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex';
import { setPhoneFormat, resetPhoneFormat } from '@src/js/inputMasks.js';

import Button from '@components/ui/button.vue';
import Count from '@components/ui/count.vue';
import DatePicker from '@components/ui/datepicker.vue';
import Comment from '@components/ui/comment.vue';
import Promocode from '@components/ui/promocode.vue';
import Deliveryperiod from '@components/ui/deliveryperiod.vue';
import AddressList from '@components/ui/addresslist.vue';

let PageComponent = {
  name: 'order',
  data() {
    return {
      newAddresBlockVisible: false,
      template: '<p>default temp</p>',
      deliveryAddress: [],
      deliveryDate: null,
      deliveryDateError: false,
      deliveryPeriod: '',
      deliveryPeriodError: false,
      deliveryAddressId: '',
      deliveryAddressData: {
        id: null,
        phone: null,
        comment: null,
      },
      payment: 'money',
      comment: '',
      newAddress: '',
      guest: {
        username: '',
        phone: '',
      },
      guestAddress: {
        value: '',
        comment: '',
        phone: '',
      },
      guestAddressErrors: {
        value: '',
        valueText: '',
      },
      guestErrors: {
        username: false,
        phone: false,
        usernameText: '',
        phoneText: '',
      },
      errorsText: {
        empty: 'Поле не должно быть пустым',
        shortPassword: 'Пароль должен быть 6 и более символов',
        mismatchPassword: 'Введеные пароли не совпадают',
        incorrectPassword: 'Неверный пароль',
        incorrectUser: 'Пользователя с таким телефоном не существует',
      },
    };
  },
  components: {
    't-button': Button,
    't-count': Count,
    't-datepicker': DatePicker,
    't-comment': Comment,
    't-promocode': Promocode,
    't-delivery-period': Deliveryperiod,
    't-address-list': AddressList,
  },
  computed: {
    ...mapState('params', ['shoppingCart', 'mobile', 'auth']),
    ...mapState('cart', ['cart', 'promocode']),
    ...mapGetters('cart', [
      'getSummaryCart',
      'isPromocodeActive',
      'getDiscountFormat',
    ]),
    ...mapState('api', ['order']),
    leftMenuVisible: function() {
      return window.innerWidth < 1280;
    },
  },
  methods: {
    ...mapMutations('cart', [
      'addItemToCart',
      'removeFromCart',
      'clearPromocode',
      'clearCart',
    ]),
    ...mapMutations('params', ['toogleConfirmBlock', 'toggleRightMenu']),
    ...mapActions('api', ['fetchRequest']),

    setTemplate: function(template) {
      this.template = template.data;
    },
    setData: function(data, to) {
      this.setTemplate(data);
    },
    setDeliveryDate: function(date) {
      this.deliveryDate = date;
    },
    setDeliveryPeriod: function(id) {
      this.deliveryPeriod = id;
    },
    setComment: function(value) {
      this.comment = value;
    },
    setNewAddresBlockVisible: function() {
      this.newAddresBlockVisible = !this.newAddresBlockVisible;
    },
    addNewAddres: function() {
      this.newAddresBlockVisible = false;
    },
    form: function(data) {
      let _form = new FormData();
      Object.keys(data).forEach((item) => {
        _form.append(item, data[item]);
      });
      return _form;
    },
    orderConfirm: function() {
      if (this.auth) {
        if (this.validation()) return;

        this.fetchRequest({
          url: this.order,
          form: this.form({
            comment: this.comment,
            payment: this.payment,
            deliveryDate: this.deliveryDate.replace(/\s/g, ''),
            deliveryAddressId: this.deliveryAddressId,
            deliveryAddressText: this.deliveryAddressId,
            deliveryPeriod: this.deliveryPeriod,
            cart: this.createCart(this.cart),
            promoCode: this.promocode ? this.promocode.promo : null,
          }),
          success: (data) => {
            console.log('success', data);
            if (data.body.success) {
              if (data.body.formUrl) {
                window.location = data.body.formUrl;
              } else {
                this.clearPromocode();
                this.clearCart();
                this.toggleRightMenu();
                this.toogleConfirmBlock({
                  title: 'Ваш заказ принят',
                  text: 'Наш менеджер свяжется с Вами',
                });
              }
            } else {
              this.toggleRightMenu();
              try {
                this.toogleConfirmBlock({
                  title: 'Ошибка',
                  text: data.body.errors.cart[0],
                  error: true,
                });
              } catch (e) {
                this.toogleConfirmBlock({
                  title: 'Ошибка',
                  text:
                    'Произошла неизвестная ошибка. Повторите заказ еще раз, пожалуйста',
                  error: true,
                });
              }
            }
          },
          error: (e) => {
            console.log('error', e);
          },
        });
      } else {
        if (this.guestValidation()) return;

        this.fetchRequest({
          url: this.order,
          form: this.form({
            username: this.guest.username,
            phone: this.createPhone(this.guest.phone),
            comment: this.comment,
            payment: this.payment,
            deliveryDate: this.deliveryDate.replace(/\s/g, ''),
            deliveryAddressText: this.guestAddress.value,
            deliveryAddressComment: this.guestAddress.comment,
            deliveryAddressPhone: this.guestAddress.phone,
            deliveryPeriod: this.deliveryPeriod,
            cart: this.createCart(this.cart),
            promoCode: this.promocode ? this.promocode.promo : null,
          }),
          success: (data) => {
            console.log('success', data);
            if (data.body.success) {
              if (data.body.formUrl) {
                window.location = data.body.formUrl;
              } else {
                this.clearPromocode();
                this.clearCart();
                this.toggleRightMenu();
                this.toogleConfirmBlock({
                  title: 'Ваш заказ принят',
                  text: 'Наш менеджер свяжется с Вами',
                });
              }
            } else {
              this.toggleRightMenu();
              try {
                this.toogleConfirmBlock({
                  title: 'Ошибка',
                  text: data.body.errors.cart[0],
                  error: true,
                });
              } catch (e) {
                this.toogleConfirmBlock({
                  title: 'Ошибка',
                  text:
                    'Произошла неизвестная ошибка. Повторите заказ еще раз, пожалуйста',
                  error: true,
                });
              }
            }
          },
          error: (e) => {
            console.log('error', e);
          },
        });
      }
    },
    setAddress: function(data) {
      if (!data) return;

      this.deliveryAddressId = data.id;
      this.deliveryAddressData = { ...data };
    },
    createCart: function(array) {
      return JSON.stringify(
        array.map((item) => {
          let result = {
            id: item.id,
            count: item.count,
          };

          if (item.installment) {
            result.installment = item.installment;
          }

          return result;
        })
      );
    },
    // Guest mode
    setErrors: function(id, error) {
      this.guestErrors[id] = true;
      this.guestErrors[id + 'Text'] = this.errorsText[error];
    },
    phoneFormat: function({ target }) {
      target.value = target.value.replace(/[a-zA-z]/g, '');

      this.guest.phone = setPhoneFormat(target.value);
    },
    phoneFormatAddress: function({ target }) {
      target.value = target.value.replace(/[a-zA-z]/g, '');

      this.guestAddress.phone = setPhoneFormat(target.value);
    },
    createPhone: function(value) {
      return resetPhoneFormat(value).slice(1);
    },
    validation: function() {
      let error = false;

      if (!this.deliveryDate) {
        this.deliveryDateError = true;
        error = true;
      }
      if (!this.deliveryPeriod) {
        this.deliveryPeriodError = true;
        error = true;
      }

      return error;
    },
    guestValidation: function() {
      let error = false;
      /*
        Object.keys(this.guest).forEach((item) => {
          if (!this.guest[item].trim()) {
            this.setErrors(item, 'empty');
            error = true;
          }
        });
      */
      if (this.guest.phone.length < 17) {
        this.setErrors('phone', 'empty');
        error = true;
      }

      if (!this.guest.username.trim()) {
        this.setErrors('username', 'empty');
        error = true;
      }

      if (!this.deliveryDate) {
        this.deliveryDateError = true;
        error = true;
      }
      if (!this.deliveryPeriod) {
        this.deliveryPeriodError = true;
        error = true;
      }

      return error;
    },
    clearError: function(type, id) {
      this[type + 'Errors'][id] = false;
    },
    clearDeliveryDateError: function() {
      this.deliveryDateError = false;
    },
    clearDeliveryPeriodError: function() {
      this.deliveryPeriodError = false;
    },
    setDeliveryAddress: function(array) {
      this.deliveryAddress = [...array];
    },
  },
  beforeRouteUpdate(to, from, next) {
    next();
  },
  beforeRouteEnter(to, from, next) {
    let order = document.querySelector('#order');
    if (order) {
      order.remove();
    }

    let url = '/api/templates/order';
    Vue.http.get(url, { params: to.query }).then((data) => {
      next((vm) => vm.setData(data));
    });
  },
  render(createElement) {
    return Vue.compile(this.template).render.call(this, createElement);
  },
  created() {
    if ('success' in this.$route.query) {
      this.clearPromocode();
      this.clearCart();
      this.toggleRightMenu();
      this.toogleConfirmBlock({
        title: 'Ваш заказ принят',
        text: 'Оплата заказа прошла успешно',
      });
    }
    if ('fail' in this.$route.query) {
      this.toggleRightMenu();
      this.toogleConfirmBlock({
        title: 'Оплата не прошла',
        text: 'Повторите попытку',
        error: true,
      });
    }
  },
};

export default PageComponent;



// WEBPACK FOOTER //
// ./src/templates/pages/order/index.js